<!-- Loading spinner -->
<!-- <div class="table-loading-shade" *ngIf="loading$ | async">
  <mat-spinner class="mat-spinner-color"></mat-spinner>
</div> -->
<!-- /Loading spinner -->
<h1 mat-dialog-title>Add {{type}}</h1>

<div mat-dialog-content style="width: 480px;">
  <form [formGroup]="formDailyLog" (ngSubmit)="saveFormDailyLog()">
    <ng-container class="mt-3" *ngIf="type=='Comment'">
      <mat-form-field class="example-form-field full-width" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="log_description" required></textarea>


      </mat-form-field>
      <div class="text-end mt-3">
        <div class="">

          <button mat-raised-button type="submit" color="primary" class="savebtn me-1">
            Add
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="type == 'Attachment'">
      <div class="attachment-container">
        <div class="attachment-grid">
          <div class="attachment-item" *ngFor="let file of filesList; let i = index">
            <div class="media-box">
              <img *ngIf="isImage(file)" [src]="file.preview" alt="Preview" />
              <video *ngIf="isVideo(file)" [src]="file.preview" controls></video>
              <img *ngIf="isDocument(file)" src="./../../../../../resources/assets/img/pdf-box.png" alt="Doc Preview" />
              <button class="remove-icon" (click)="removeFile(i)">✖</button>
            </div>
            <p class="file-label">{{ file.file.name }}</p>
          </div>
        </div>

        <div class="upload-controls">
          <input type="file" (change)="onFileChange($event)" #fileInput
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,image/,video/" multiple hidden />
          <button (click)="fileInput.click()" class="upload-button">Upload File</button>
        </div>

        <div class="save-button-wrapper">
          <button mat-raised-button type="submit" color="primary" class="save-button" (click)="saveFile()">Save</button>
        </div>
      </div>
    </ng-container>

  </form>
</div>